import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import { ReactComponent as CheckIcon } from '@doveconviene/sf-ui/icons/check.svg'
import Icon from '../../../ui/Icon'

const StyledListItem = styled.div(({
  display: 'flex',
  height: '40px',
  alignItems: 'center',
}))

const StyledText = styled.span(({ theme: { colors }, checked }) => ({
  color: checked ? colors.dark_grey : colors.mid_grey,
  flex: '1 1 auto',
  fontSize: '14px',
}))

const StyledCheckIcon = styled.div(({ theme }) => ({
  flex: '0 0 auto',
  color: theme.colors.primary,
  cursor: 'pointer',
  width: '24px',
  height: '24px',
  marginRight: '8px',
}))

const CategoryListItem = ({
  children, id, checked, onSelect,
}) => (
  <StyledListItem onClick={() => onSelect(id)} data-test="CategoryListItem">
    <StyledText checked={checked}>
      {children}
    </StyledText>
    {checked ? (
      <StyledCheckIcon>
        <Icon>
          <CheckIcon />
        </Icon>
      </StyledCheckIcon>
    ) : null}
  </StyledListItem>
)

CategoryListItem.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.string,
  checked: PropTypes.bool,
  onSelect: PropTypes.func,
}

CategoryListItem.defaultProps = {
  children: '',
  checked: false,
  onSelect: () => false,
}

CategoryListItem.displayName = 'CategoryListItem'
CategoryListItem.whyDidYouRender = true

export default React.memo(CategoryListItem)
